import styled from 'styled-components';

export const MainContainer = styled.div``;

export const Separator = styled.div`
  min-height: 0.5vh;
`;

type StickyHeaderPros = {
  showStick: boolean;
};

export const StickHeader = styled.div<StickyHeaderPros>`
  margin-left: -2.2%;
  margin-right: -30px;
  display: ${props => (props.showStick ? 'flex' : 'none')};
  justify-content: flex-end;
  position: -webkit-sticky;
  z-index: 700;
  position: sticky;
  top: 0;
  background-color: white;
  font-size: 18px;
  font-weight: 700;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 16px #00000029;
  min-height: 50px;
  align-items: center;
  a {
    color: #222247;
    text-decoration: none;
  }
  @media only screen and (max-width: 900px) {
    display: none;
  }
`;

export const ProfileHeading = styled.div`
  margin: 0px 10px 10px 0px;
  display: flex;
  font-size: 24px;
  font-weight: bold;
  button {
    margin: 0px;
  }
`;

export const StickHeaderLinks = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 50px;
  margin-right: 30px;
`;

type StatusElipseProps = {
  color: string;
};

export const StatusElipse = styled.div<StatusElipseProps>`
  width: 20px;
  height: 20px;
  /* UI Properties */
  background: ${props => props.color} 0% 0% no-repeat padding-box;
  border-radius: 10px;
  cursor: pointer;
  &:hover > #tooltip {
    display: inline-block;
  }
`;

export const RelativeContainer = styled.div`
  position: relative;
  display: none;
`;

export const TooltipText = styled.span`
  min-width: 100px;
  background-color: #fff;
  color: #1c1b3a;
  text-align: center;
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 20px;
`;
